import { Option } from '@/lib/v2/components';

let id = 1;

type IdGeneratorParams = {
  type?: string;
  trigger?: Option;
};

export const getId = ({ type, trigger }: IdGeneratorParams = {}): string => {
  if (!type) {
    return `${id++}`;
  }

  const prefix = type.toLowerCase();
  const triggerValue = trigger?.value?.toString().toLowerCase().replace(/\s+/g, '-') ?? '';

  return triggerValue ? `${prefix}-${triggerValue}` : prefix;
};
